import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Button, DatePicker } from 'yankees-react-utils';
import useOpposingTeamSelector from '../../../../utils/useOpposingTeamSelector';
import useConfig from '../../../../utils/useConfig';
import usePlayerSelector from '../../../../utils/usePlayerSelector';

const getHandednessOptions = (opposingTeam, batter, isLhb, translate) => {
    const handednessOptions = [
        { name: `${translate('baseball.abbr-versus')} ${translate('baseball.lhh')}`, value: 2 },
        { name: `${translate('baseball.abbr-versus')} ${translate('baseball.rhh')}`, value: 3 },
    ];
    return [
        ...(opposingTeam.LevelIDData === 8 ? [{ name: `${translate('baseball.abbr-versus')} ${batter.FullName}`, value: 1 }] : []),
        ...(isLhb ? handednessOptions : handednessOptions.reverse()),
    ];
};
const Filters = ({ isLhb, year, setYear, startDate, setStartDate, endDate, setEndDate, handedness, setHandedness }) => {
    const { t: translate } = useTranslation();
    const { CurrentYear, UsePreviousYearData } = useConfig();

    const [innerYear, setInnerYear] = useState(year);
    const [innerStartDate, setInnerStartDate] = useState(startDate);
    const [innerEndDate, setInnerEndDate] = useState(endDate);
    const [innerHandedness, setInnerHandedness] = useState(handedness);

    const opposingTeam = useOpposingTeamSelector();
    const batter = usePlayerSelector();

    const singleYearOptions = window.$IsDugoutApp ? [CurrentYear] : [CurrentYear, CurrentYear - 1, CurrentYear - 2];
    const yearOptions = [
        { name: `${CurrentYear - 1} - ${CurrentYear}`, value: -1 },
        ...(singleYearOptions.map((y) => ({ name: y, value: y }))),
    ];

    const handednessOptions = useMemo(() => getHandednessOptions(opposingTeam, batter, isLhb, translate), [opposingTeam, batter, isLhb, translate]);

    useEffect(() => {
        setYear(yearOptions[UsePreviousYearData ? 0 : 1]);
        setInnerYear(yearOptions[UsePreviousYearData ? 0 : 1]);
        setHandedness(handednessOptions[0]);
        setInnerHandedness(handednessOptions[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onFilter = () => {
        setYear(innerYear);
        setStartDate(innerStartDate);
        setEndDate(innerEndDate);
        setHandedness(innerHandedness);
    };

    return (
        <div className="d-flex justify-content-end align-items-center">
            {innerHandedness?.value === 1 || window.$IsDugoutApp
                ? (
                    <Dropdown
                        align="end"
                        options={yearOptions}
                        value={innerYear}
                        onSelect={setInnerYear}
                    />
                )
                : (
                    <>
                        <div style={{ width: '120px', flexShrink: 0 }}>
                            <DatePicker
                                size="sm"
                                maxDate={new Date()}
                                value={innerStartDate}
                                onSelect={(value) => setInnerStartDate(value)}
                                openToDate={innerStartDate}
                            />
                        </div>
                        <span className="mx-2">{translate('common.to')}</span>
                        <div style={{ width: '120px', flexShrink: 0 }}>
                            <DatePicker
                                size="sm"
                                maxDate={new Date()}
                                value={innerEndDate}
                                onSelect={(value) => setInnerEndDate(value)}
                                openToDate={innerEndDate}
                            />
                        </div>
                    </>
                )}
            <div className="mx-2">
                <Dropdown
                    align="end"
                    options={handednessOptions}
                    value={innerHandedness}
                    onSelect={setInnerHandedness}
                />
            </div>
            <Button
                variant="primary"
                onClick={onFilter}
            >
                {translate('common.update')}
            </Button>
        </div>
    );
};

export default Filters;
